import Favourite from '../components/Favourite/Favourite';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Banner from '../components/Banner';

const FavouritePage = () => {
   return (
      <div>
         <Header />
         <Banner />
         <Favourite />
         <Footer />
      </div>
   );
};

export default FavouritePage;
